import { Pagination } from '@mui/material'
import { useStyles } from './styles'
import { useState } from 'react'

type AppPaginationProps = {
  onChange: () => void
  count: number
}

export const AppPagination = (props: AppPaginationProps) => {
  const { onChange, count } = props
  const { classes } = useStyles()
  const [currentPage, setCurrentPage] = useState(1)

  const handleChange = (_: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page)
    onChange()
  }

  return (
    <div className={classes.root}>
      <Pagination
        onChange={handleChange}
        count={count}
        page={currentPage}
        className={classes.pagination}
        shape="rounded"
      />
    </div>
  )
}
